<template lang="">
  <div class="cardContent">
    <div class="table-box">
      <div class="tableTitle flex">
        <div style="width:12%">序号</div>
        <div style="width:30%">名称</div>
        <div style="width:40%">承担单位</div>
        <div style="width:18%">建设进度</div>
      </div>
      <div class="tableBody" @click.stop="handleSectionClick($event)">
        <vue-seamless-scroll
          :data="tableData"
          style="height:100%;"
          :class-option="classOption"
        >
          <ul>
            <li
              v-for="(item, index) in tableData"
              :key="index"
              class="flex content"
              :data-id="item.id"
            >
              <div style="width:12%;">{{ index + 1 }}</div>
              <div style="width:30%;">{{ item.name }}</div>
              <div style="width:40%;">
                {{ item.orgCompanyName }}
              </div>
              <div style="width:18%;">
                {{ item.completion }}
              </div>
            </li>
          </ul>
        </vue-seamless-scroll>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { findIndexByName } from "@/util/index";
export default {
  components: {},
  computed: {
    ...mapGetters(["rightComponentBak"]),
    classOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true // 开启数据实时监控刷新dom
      };
    }
  },
  props: {
    //是否滚动, 默认滚动
    isScrolled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tableData: []
    };
  },
  mounted() {
    // this.getTableData();
    if (sessionStorage.getItem("updXmjsData")) {
      this.tableData = JSON.parse(sessionStorage.getItem("updXmjsData"));
      console.log("updx", this.tableData);
    }
    this.$bus.$on("updXmjsData", d => {
      this.tableData = d;
      sessionStorage.setItem("updXmjsData", JSON.stringify(d));
    });
  },
  destroyed() {
    this.$bus.$off("updXmjsData");
  },
  methods: {
    // 处理vue-seamless-scroll click不生效问题
    handleSectionClick(e) {
      let target = e.target;
      if (target.tagName == "DIV") {
        if (target.parentNode.tagName == "LI") {
          this.showDt(target.parentNode.dataset.id);
        }
      }
      if (target.tagName == "LI") {
        this.showDt(target.dataset.id);
      }
    },
    showDt(id) {
      console.log("in showDt", id);
      let index = findIndexByName(id, this.tableData, "id");
      if (index > -1) {
        const item = this.tableData[index];
        // 缓存rightcomponent
        sessionStorage.setItem("rightComponent", this.rightComponentBak);
        setTimeout(() => {
          this.$store.dispatch("drawer/setGraphic", item);
          this.$store.dispatch("drawer/setRightComponent", "yqztzDrawer");
        }, 10);
      }
    }
    /* getTableData() {
      this.tableData = [
        {
          name: "贷款贴息",
          orgCompanyName: "茂名市名园农业有限公司",
          completion: "30%"
        },
        {
          name: "农业设施",
          orgCompanyName: "茂名市名园农业有限公司",
          completion: "20%"
        },
        {
          name: "科技与信息支撑",
          orgCompanyName: "茂名市名园农业有限公司",
          completion: "40%"
        },
        {
          name: "产业融合",
          orgCompanyName: "茂名市名园农业有限公司",
          completion: "30%"
        },
        {
          name: "土地流转",
          orgCompanyName: "茂名市名园农业有限公司",
          completion: "20%"
        },
        {
          name: "公共区域品牌",
          orgCompanyName: "茂名市名园农业有限公司",
          completion: "40%"
        }
      ];
    } */
  }
};
</script>

<style lang="stylus" scoped>
.cardContent
  height 1000%
.table-box
      width 460px
      margin 0 auto
      .tableTitle
        background transparent
        color #fff
        padding 8px 5px
        font-size 15px
        text-align center
        justify-content center

      .tableBody
        height 380px
        overflow hidden
        font-size 13px

      .scroll-content
        position relative
        transition top .1s

      .content
        padding 0px 5px
        line-height 1.5
        color #fff
        cursor pointer
        text-align center
        .money-num
          font-size 20px
          color #FCDC00
        .sale-num
          font-size 20px
          color #02c8f4

      .content:nth-child(2n+1)
        line-height 1.5
        background #003c5e
        // border-radius 17px
</style>
